import { useTranslation } from "react-i18next";
import { Tag } from "../../Tag/Tag";
import "../../../../../i18n/i18n";
import { colorTagProps } from "./colorTagProps";

type Status = "IN_CIRCULATION" | "ORDERED" | "DEACTIVATED";
const statusEnum = ["IN_CIRCULATION", "ORDERED", "DEACTIVATED"];

const statusProps: Record<Status, (typeof colorTagProps)[keyof typeof colorTagProps]> = {
  IN_CIRCULATION: colorTagProps.success,
  ORDERED: colorTagProps.informative,
  DEACTIVATED: colorTagProps.neutral,
};

export const TableTagVehicleStatus = (props: { status: Status }) => {
  const { t } = useTranslation();

  const statusKey = statusEnum.find(
    (s) => t(`vehicles.status.${s}`) === props.status,
  ) as Status;

  if (!statusKey) {
    return "";
  }

  const render = statusProps[statusKey];

  return (
    props.status && (
      <Tag
        text={props.status}
        backgroundColor={render.backgroundColor}
        textColor={render.textColor}
        iconColor={render.iconColor}
        //iconLeft={render.iconLeft}
      />
    )
  );
};
